import React, { Fragment, memo } from 'react';
import { Row, Col, Divider, Spin, Icon, Layout } from 'antd';
import { useHistory } from 'react-router-dom'
import Footer from '../../component/layout/Footer';
import Header from '../../component/layout/Header';
import UserSession from '../../service/UserSession';
import UpdateProfileWithForm from './UpdateProfileForm';
import UpdatePasswordWithForm from './UpdatePasswordForm';
import { useQuery } from "@apollo/react-hooks";
import { GET_USER_QUERY } from '../../constants/graphql-query';

const UserProfile = (props) => {

    const { loading, data } = useQuery(GET_USER_QUERY, {
        variables: { id: UserSession.getLogonId() },
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    });

    const { Content } = Layout;

    return (
        <Fragment>
            <Header />
            {
                loading ? (
                    <Spin className="loading" indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} />  
                ) : (
                    <Content className="main-content">
                        <Row type="flex" align="middle" justify="center" gutter={[0, 0]} className="form-container">
                            <Col span={6}>
                                <Row>
                                    <Col span={24}>
                                        <h3><strong>User Profile</strong></h3>
                                    </Col>
                                    <Col span={24}>
                                        <UpdateProfileWithForm data={data} />
                                    </Col>
                                </Row>

                            </Col>
                            <Col span={4} align="center">
                                <Divider className="vertical-line" type="vertical" />
                            </Col>
                            <Col span={6}>
                                <UpdatePasswordWithForm data={data}/>
                            </Col>
                        </Row>
                    </Content>
                )
            }
            <Footer />
        </Fragment>
    )
}

export default memo(UserProfile);
